// One definition of "is this task an employee enrollment-request (pending broker
// approval)" so the employee /benefits page, the broker employee profile, and
// the tasks page all classify it the same way.
export function isEnrollmentRequestTask(task: any): boolean {
  if (!task) return false;
  return (
    task.category === "plan_changes" &&
    (task.subcategory === "enrollment_request" ||
      (task.customFields as any)?.action === "enrollment_request")
  );
}

// True only while the request is still awaiting broker approval. Once the broker
// approves, `enrollmentApproved` is set and the elections exist as real
// enrollments — the task may linger as open/in_progress while the broker works
// the carrier checklist, but the employee should no longer see "pending review".
// (The broker UI gates Approve/Deny on the same flag.)
export function isPendingEnrollmentRequestTask(task: any): boolean {
  return (
    isEnrollmentRequestTask(task) &&
    (task?.customFields as any)?.enrollmentApproved !== true
  );
}
